import type { Playlist } from 'types/playlist'
import {
  INBOX_TYPES,
  PERSONAL_INBOX,
  TEAM_INBOX,
} from '@disco/constants/GroupTypes'
export const getInboxType = (
  libraryGroupType?: string,
  inboxType?: string,
): (boolean | null | undefined) | (string | null | undefined) => {
  const isInboxGroup =
    libraryGroupType && INBOX_TYPES.includes(libraryGroupType)
  if (!libraryGroupType && !isInboxGroup) return
  if (!inboxType) return isInboxGroup
  if (inboxType && isInboxGroup) return libraryGroupType === inboxType
}
export const getOwner = (
  playlist: Playlist,
  libraryGroupType?: string,
): string | null | undefined => {
  const { origin, owner, share, is_welcome_to_disco_playlist } = playlist

  const inboxGroup = (inboxType?: string) =>
    getInboxType(libraryGroupType, inboxType)

  const businessLibrary = origin?.primary_library || inboxGroup()
  const businessMemberDetails = owner?.member_of_business && owner?.email
  const libraries = origin?.source_library || origin?.primary_library

  if (origin && origin.business && businessLibrary) {
    if (inboxGroup(TEAM_INBOX) || inboxGroup(PERSONAL_INBOX)) {
      // When playlist is set from Catalog
      if (!share && origin.source_library) return origin.business?.name
      // When playlist is sent from Share page or uploaded
      if (share?.user_detail && !libraries) return owner?.email
      return origin.business?.name
    }

    return origin?.business?.name
  }

  // if there is no business, return the owner email to inboxes
  if (
    !origin?.business &&
    (inboxGroup(PERSONAL_INBOX) || inboxGroup(TEAM_INBOX))
  ) {
    if (businessMemberDetails) return owner?.email
  }

  // Welcome to Disco is a special case where we want to show the business name
  if (is_welcome_to_disco_playlist && origin?.business)
    return origin.business.name
  // Playlist sent from non-DISCO user
  if (!owner?.member_of_business && owner?.email) return owner.email
}
